









import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import BaseTitle from "./base-title.vue";
import { uncodeUtf16 } from "@/api/net/util.ts";
@Component({
  components: {
    BaseTitle
  }
})
export default class OrderOther extends Vue {
  @Prop(String) remark!: string;

  public get remarkContent(): string | null {
    if (this.remark) {
      return uncodeUtf16(this.remark);
    } else {
      return null;
    }
  }
}
